module.exports = __webpack_public_path__ + "static/img/_F5T3862-1080p.af43abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio3/_F5T3862-1080p.jpg
// module id = yyUV
// module chunks = 0